import PropTypes from 'prop-types'
import * as React from 'react'

import Panel from 'components/panel'
import Shim from 'components/Shim'
import { StructuredText } from 'prismic/components/base'
import * as Context from './Context'

import 'photoswipe/style.css'
import styles from './Forecast.module.css'

Footer.propTypes = {
    children: PropTypes.node,
}

export default function Footer({ children }) {
    return (
        <footer className={styles.Footer}>
            {children || (
                <React.Fragment>
                    <Disclaimer />
                </React.Fragment>
            )}
        </footer>
    )
}

export function Inbox() {
    return <Prismic uid="forecast-rss-message" />
}

export function Disclaimer({ uid = 'forecast-disclaimer', expanded }) {
    return <Prismic uid={uid} expanded={expanded} />
}

export function Prismic({ uid, expanded }) {
    const documents = Context.useDocuments()
    const { data = null } = documents.get(uid) || {}

    if (!data) return null

    return (
        <Panel header={data.title} expanded={expanded}>
            <Shim horizontal>
                <StructuredText value={data.body} />
            </Shim>
        </Panel>
    )
}
